// frontend/src/constants/operators.const.ts
// Список оперативных дежурных ГМСКЦ
// Источник истины — таблица duty_operators (GET /api/admin/settings/duty-operators).
// Константа — резервный список при недоступности API; состав поддерживать синхронно с сидом 000-full-schema.sql.

// Версия списка операторов — при изменении данных увеличить на 1.
// localStorage с устаревшей версией автоматически сбрасывается.
export const OPERATORS_VERSION = 3;
// v3 (2026-09-10): ротация ОД — добавлен Мамонов А. В., исключён Локотьков А. В.

export interface Operator {
  id: string;
  fullName: string;
  shortName: string; // Инициалы для подписи (С. А. Мохначёв)
  email: string;
}

export const OPERATORS: Operator[] = [
  {
    id: 'biragov',
    fullName: 'Бирагов Вячеслав Терентьевич',
    shortName: 'В. Т. Бирагов',
    email: 'biragov.vt@morspas.ru',
  },
  {
    id: 'buneev',
    fullName: 'Бунеев Александр Фёдорович',
    shortName: 'А. Ф. Бунеев',
    email: 'buneev.af@morspas.ru',
  },
  {
    id: 'buryi',
    fullName: 'Бурый Олег Евгеньевич',
    shortName: 'О. Е. Бурый',
    email: 'buryi.oe@morspas.ru',
  },
  {
    id: 'mamonov',
    fullName: 'Мамонов Андрей Владимирович',
    shortName: 'А. В. Мамонов',
    email: 'mamonov.av@morspas.ru',
  },
  {
    id: 'mokhnachev',
    fullName: 'Мохначёв Сергей Александрович',
    shortName: 'С. А. Мохначёв',
    email: 'mokhnachev.sa@morspas.ru',
  },
];
